import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { useWebViewBridge } from '@fourthwall/webview-bridge';
export const DirtyContext = createContext(undefined);
export const DirtyProvider = ({ children }) => {
    const [isDirty, setIsDirty] = useState(false);
    const webViewBridge = useWebViewBridge();
    useEffect(() => {
        setSiteDesignerDirty(isDirty);
    }, [isDirty]);
    const setSiteDesignerDirty = async (isDirty) => {
        await webViewBridge.methods.setSiteDesignerDirty?.(isDirty);
    };
    const value = useMemo(() => ({
        isDirty,
        setIsDirty,
    }), [isDirty, setIsDirty]);
    return React.createElement(DirtyContext.Provider, { value: value }, children);
};
export const useDirtyContext = () => {
    const dirtyContext = useContext(DirtyContext);
    if (dirtyContext === undefined) {
        throw new Error('dirtyContext must be used within a DirtyProvider');
    }
    return dirtyContext;
};
